<template>
    <div id="line">
        <apexchart type="line" height="250" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
export default {
  components: {
    apexchart: VueApexCharts,
  },
  name: 'Vue Chart',
  
  props: {
    Y: Array,
    X: Array,
    title: String
  },
  data: function () {
  return {
   chartOptions: {
    chart: {
      id: 'vuechart-example',
      zoom: {
        enabled: false,
        autoScaleYaxis: false,  
      }
    },
    xaxis: {
      categories: this.X,
    },
    title: {
        text: this.title,
        style: {
            fontSize: '16px'
        },
        offsetY: 5
    },
    stroke: {
          show: true,
          width: 2,
          colors: ['#5E67BA']
        },
   },
   series: [{
    name: 'Vue Chart',
    data: this.Y
   }]
  }
 },
 methods: {
  updateChart() {
   const max = 90;
   const min = 20;
   const newData = this.series[0].data.map(() => {
     return Math.floor(Math.random() * (max - min + 1)) + min
   })
   // In the same way, update the series option
   this.series = [{
    data: newData
   }]
  }
 }
}
</script>
<style>
  #line {
       border: 1px solid #AAA;
       border-radius: 7px;
       @media (max-width: 768px ){
      }
    }
</style>